"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Breadcrumb_1 = __importDefault(require("react-bootstrap/Breadcrumb"));
var element_type_enum_1 = __importDefault(require("../../shared/enums/element-type.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var icon_1 = __importDefault(require("../icon"));
require("./breadcrumb.scss");
function Breadcrumbs(props) {
    return (react_1.default.createElement(Breadcrumb_1.default, { as: props.elementType || element_type_enum_1.default.H2,
        listProps: {
            className: "bg-transparent p-0 m-0"
        },
        className: (0, classMap_1.default)("mpng-ux-breadcrumbs", props.className) }, props.items.map(function (child, key) {
        var last = props.items.length === key + 1;
        return (react_1.default.createElement(Breadcrumb_1.default.Item, { onClick: !last ? child.callback : undefined,
            active: last, key: key, className: child.className,
            linkProps: {
                className: "breadcrumb-link"
            } },
            react_1.default.createElement("span", null, child.title),
            !last && (react_1.default.createElement("span", { className: "ps-3 separator" }, typeof props.separator === "string" ? props.separator : react_1.default.createElement(icon_1.default, __assign({}, props.separator))))));
    })));
}
exports.default = Breadcrumbs;
